import Calendar from './src/calendar2.mjs';
export { calendarEmits, calendarProps } from './src/calendar.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElCalendar = withInstall(Calendar);

export { ElCalendar, ElCalendar as default };
//# sourceMappingURL=index.mjs.map
